@if (disabled) {
  <div class="acc-bar acc-bar--disabled" aria-disabled="true">
    <i class="ph {{ icon }} acc-bar__icon" [class.acc-bar__icon--import]="kind === 'import'" aria-hidden="true"></i>
    <span class="acc-bar__label">{{ labelKey | translate }}</span>
    <i class="ph ph-caret-down acc-bar__caret" aria-hidden="true"></i>
  </div>
  @if (tooltip) {
    <span class="acc-bar__tooltip" role="tooltip">{{ tooltip }}</span>
  }
} @else {
  <button type="button" class="acc-bar" [disabled]="frozen" (click)="onClick()">
    <i class="ph {{ icon }} acc-bar__icon" [class.acc-bar__icon--import]="kind === 'import'" aria-hidden="true"></i>
    <span class="acc-bar__label">{{ labelKey | translate }}</span>
    <i class="ph ph-caret-down acc-bar__caret" aria-hidden="true"></i>
  </button>
}
